import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";
import { PRIVACY_SECTIONS, PRIVACY_VERSION } from "@/lib/privacy";

export const PrivacyPolicyModal = ({ open, onClose }) => (
  <AnimatePresence>
    {open && (
      <>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose}
          className="fixed inset-0 z-[100] bg-black/60 backdrop-blur-sm"
        />
        <div className="fixed inset-0 z-[110] flex items-center justify-center p-4 pointer-events-none">
          <motion.div
            initial={{ opacity: 0, y: 40, scale: 0.97 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 24, scale: 0.98 }}
            transition={{ duration: 0.45, ease: [0.16, 1, 0.3, 1] }}
            data-testid="privacy-modal"
            className="pointer-events-auto w-full max-w-2xl max-h-[85vh] bg-white border border-[#E4E4E7] flex flex-col"
          >
            <div className="flex items-center justify-between px-8 py-5 border-b border-[#E4E4E7] shrink-0">
              <div>
                <p className="font-mono-clinical text-[10px] tracking-[0.3em] uppercase text-[#6D28D9] mb-1">Aetheris Labs</p>
                <h3 className="font-display text-xl font-bold uppercase tracking-tight text-[#09090B]">Privacy Policy</h3>
              </div>
              <button onClick={onClose} data-testid="privacy-close" className="p-2 text-[#71717A] hover:text-[#09090B] transition-colors">
                <X className="w-5 h-5" />
              </button>
            </div>
            <div className="overflow-y-auto px-8 py-6 space-y-6" data-testid="privacy-content">
              {PRIVACY_SECTIONS.map((s) => (
                <div key={s.title}>
                  <h4 className="font-display font-bold text-sm uppercase tracking-wide text-[#09090B] mb-2">{s.title}</h4>
                  {s.body.split("\n\n").map((p, i) => (
                    <p key={i} className="text-[13px] text-[#52525B] leading-relaxed mb-2 last:mb-0">{p}</p>
                  ))}
                </div>
              ))}
              <p className="font-mono-clinical text-[10px] tracking-[0.2em] uppercase text-[#A1A1AA] pt-4 border-t border-[#E4E4E7]">
                Version {PRIVACY_VERSION}
              </p>
            </div>
            <div className="px-8 py-4 border-t border-[#E4E4E7] shrink-0">
              <button
                onClick={onClose}
                data-testid="privacy-accept-close"
                className="w-full py-3.5 bg-[#6D28D9] text-white font-mono-clinical text-xs tracking-[0.15em] uppercase font-bold hover:bg-[#5B21B6] transition-colors duration-300"
              >
                Close
              </button>
            </div>
          </motion.div>
        </div>
      </>
    )}
  </AnimatePresence>
);
